var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1916 13.5701L20.6003 8.19862C20.8533 7.99191 21 7.68248 21 7.35576C21 7.02904 20.8533 6.71975 20.6003 6.51289L14.1916 1.14142C13.8498 0.849234 13.3713 0.77759 12.9589 0.956893C12.5465 1.1362 12.2724 1.53503 12.253 1.98429V4.10289C3.25575 2.5443 1 10.5958 1 15.1416C3.08717 11.6787 8.49582 5.40144 12.253 10.5958V12.7201C12.2699 13.1707 12.5429 13.572 12.9557 13.753C13.3687 13.934 13.8488 13.863 14.1916 13.5701Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.d4ca43c64b0b0554ba044807724ab1d2.svg";
export { ForwardRef as ReactComponent };